import { createSlice } from '@reduxjs/toolkit';
import { clientResource } from '../../resources/Clients.resource';
var initialState = {
    data: []
};
export var ClientsReducer = createSlice({
    name: 'clients',
    initialState: initialState,
    reducers: {
        setClients: function setClients(state, action) {
            var data = [];
            action.payload.forEach(function (item) {
                data[item.id] = clientResource(item);
            });
            state.data = data;
        },
        updateClient: function updateClient(state, action) {
            state.data = state.data.map(function (item) {
                return item.id === action.payload.id ? action.payload : item;
            });
        },
        deleteClient: function deleteClient(state, action) {
            state.data = state.data.filter(function (item) {
                return item.id !== action.payload;
            });
        },
        addClient: function addClient(state, action) {
            state.data[action.payload.id] = clientResource(action.payload);
        }
    }
});
var _ClientsReducer$actio = ClientsReducer.actions, setClients = _ClientsReducer$actio.setClients, deleteClient = _ClientsReducer$actio.deleteClient, addClient = _ClientsReducer$actio.addClient, updateClient = _ClientsReducer$actio.updateClient;
export { setClients, deleteClient, addClient, updateClient };
export default ClientsReducer.reducer;
